module.exports = __webpack_public_path__ + "img/th-logo.30ba5c88.png";